import {
  CRUISE_HERO_IMAGE,
  CRUISE_SEARCH_BANNER,
  getCruiseCityMeta,
  getDealImage,
  getRegionImage,
} from '../constants/cruiseImages';

export { CRUISE_HERO_IMAGE, CRUISE_SEARCH_BANNER };

export const CRUISE_REGIONS = [
  'Caribbean',
  'Mediterranean',
  'Alaska',
  'Northern Europe',
  'Asia Pacific',
  'South America',
];

export const TOP_CRUISE_REGIONS = [
  { id: 'caribbean', region: 'Caribbean', port: 'Miami', price: 189 },
  { id: 'mediterranean', region: 'Mediterranean', port: 'Barcelona', price: 467 },
  { id: 'alaska', region: 'Alaska', port: 'Seattle', price: 312 },
  { id: 'northern-europe', region: 'Northern Europe', port: 'Copenhagen', price: 445 },
  { id: 'asia-pacific', region: 'Asia Pacific', port: 'Singapore', price: 278 },
  { id: 'south-america', region: 'South America', port: 'Fort Lauderdale', price: 345 },
].map((item) => {
  const meta = getCruiseCityMeta(item.port);
  return {
    ...item,
    city: meta.city,
    country: meta.country,
    image: getRegionImage(item.region),
  };
});

export const CRUISE_DEALS = [
  { id: 'd1', line: 'Ocean Pearl', port: 'Miami', destination: 'Caribbean', nights: 7, dates: 'Jun 12 – Jun 19', price: 234 },
  { id: 'd2', line: 'Star Horizon', port: 'Barcelona', destination: 'Mediterranean', nights: 10, dates: 'Jul 3 – Jul 13', price: 498 },
  { id: 'd3', line: 'Royal Wave', port: 'Seattle', destination: 'Alaska', nights: 8, dates: 'Aug 15 – Aug 23', price: 156 },
  { id: 'd4', line: 'Blue Meridian', port: 'Copenhagen', destination: 'Northern Europe', nights: 9, dates: 'Sep 1 – Sep 10', price: 389 },
  { id: 'd5', line: 'Coral Queen', port: 'Singapore', destination: 'Asia Pacific', nights: 6, dates: 'Oct 4 – Oct 10', price: 212 },
  { id: 'd6', line: 'Atlantic Crown', port: 'Fort Lauderdale', destination: 'South America', nights: 11, dates: 'Nov 2 – Nov 13', price: 421 },
].map((deal) => {
  const meta = getCruiseCityMeta(deal.port);
  return {
    ...deal,
    city: meta.city,
    country: meta.country,
    image: getDealImage(deal.destination),
  };
});

export const CRUISE_FEATURES = [
  { title: 'Simple & Fast Booking', text: 'Compare cruise lines, cabins, and sailings worldwide in one search.' },
  { title: 'Assistance Available 24/7', text: 'Our cruise support team is available around the clock by phone and email.' },
  { title: 'Unbeatable Sailings', text: 'Discover top cruise deals from Caribbean to Mediterranean voyages.' },
  { title: 'Flexible Changes', text: 'Date and cabin changes backed by dedicated cruise concierge support.' },
];

export const CRUISE_REVIEWS = [
  { title: 'Smooth cruise booking', text: 'Booked a Caribbean sailing with cabin selection help. Prices were clear and support answered within minutes.' },
  { title: 'Great deals on sailings', text: 'Saved over $300 on a family Mediterranean cruise. Highly recommend Fast Fares.' },
  { title: 'Easy to change dates', text: 'Had to reschedule our departure. The team walked us through cabin and date options quickly.' },
  { title: 'Trustworthy and fast', text: 'Compared several sites—Fast Fares had the best total cruise price with no hidden add-ons.' },
];
